var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"tabindex":_vm.disabled ? -1 : 0,"disabled":_vm.disabled},on:{"click":_vm.add}},[_c('span',{class:_vm.$style.default},[_vm._v("||")]),_vm._t("default",[_vm._v("Add column")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }